var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverviewColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5,
    fill: "url(#paint0_linear_345_23952)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_345_23952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.49764 6C7.83653 6.00248 7.20317 6.26599 6.7354 6.73317C6.26763 7.20035 6.00332 7.83339 6 8.49449V12.6614C6 14.0315 7.12756 15.1654 8.49764 15.1654H12.6677C14.0409 15.1654 15.1654 14.0315 15.1654 12.6614V8.49449C15.162 7.83339 14.8977 7.20035 14.43 6.73317C13.9622 6.26599 13.3288 6.00248 12.6677 6H8.49764ZM19.3323 6C18.6712 6.00248 18.0378 6.26599 17.57 6.73317C17.1023 7.20035 16.838 7.83339 16.8346 8.49449V12.6614C16.8346 14.0315 17.9591 15.1654 19.3323 15.1654H23.5024C24.8724 15.1654 26 14.0315 26 12.6614V8.49449C25.9967 7.83339 25.7324 7.20035 25.2646 6.73317C24.7968 6.26599 24.1635 6.00248 23.5024 6H19.3323ZM8.49764 16.8346C7.83653 16.8371 7.20317 17.1006 6.7354 17.5678C6.26763 18.035 6.00332 18.668 6 19.3291V23.5024C6 24.8724 7.12756 26 8.49764 26H12.6677C13.3294 25.9975 13.9632 25.7336 14.4311 25.2657C14.8989 24.7978 15.1629 24.164 15.1654 23.5024V19.3291C15.162 18.668 14.8977 18.035 14.43 17.5678C13.9622 17.1006 13.3288 16.8371 12.6677 16.8346H8.49764ZM19.3323 16.8346C18.6712 16.8371 18.0378 17.1006 17.57 17.5678C17.1023 18.035 16.838 18.668 16.8346 19.3291V23.5024C16.8346 24.8724 17.9591 26 19.3323 26H23.5024C24.164 25.9975 24.7978 25.7336 25.2657 25.2657C25.7336 24.7978 25.9975 24.164 26 23.5024V19.3291C25.9967 18.668 25.7324 18.035 25.2646 17.5678C24.7968 17.1006 24.1635 16.8371 23.5024 16.8346H19.3323Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_345_23952",
    x1: 1.79412,
    y1: 1.18088e-7,
    x2: 32,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3DD59"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_345_23952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewColor);
export default __webpack_public_path__ + "static/media/overview-color.ab1f5f416e7d2cb1394fc2e98ca91014.svg";
export { ForwardRef as ReactComponent };